import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import swal from "sweetalert2";

@Injectable()
export class BrokerWalletGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    let userProfile = JSON.parse(window.localStorage.getItem("userProfile"));
    if (
      userProfile.role == "Admin" ||
      userProfile.role == "CFO" ||
      userProfile.role == "Property Consultant" ||
      userProfile.role == "Leader" ||
      userProfile.role == "Sales Manager"
    ) {
      return true;
    } else {
      swal("Insufficient Permissions, redirected to home", "", "error");
      this.router.navigate(["pages"]);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/broker-wallet.guard.ts